import api from "@/api/axios";

const API_URL = "/session-categories";

export const createSessionCategory = (payload) => api.post(API_URL, payload);
export const getSessionCategories = () =>  api.get(API_URL);
export const getSessionCategory = (id) =>  api.get(`${API_URL}/${id}`);
export const getSessionCategoriesForSession = (sessionId) => api.get(`${API_URL}?session_id=${sessionId}`);
export const updateSessionCategory = (id, payload) => api.put(`${API_URL}/${id}`, payload);
export const deleteSessionCategory = (id) => api.delete(`${API_URL}/${id}`);

/**
 * Welche Kategorienamen die vorhandenen Nachrichten tragen.
 *
 * Die zweite Quelle neben der Live-Sicht auf Discord — und die einzige, die
 * ohne laufenden Bot funktioniert. Sie zeigt auch die Gegenrichtung: eine
 * zugeordnete Kategorie, zu der es keine einzige Nachricht gibt.
 */
export const getKategorienImBestand = () => api.get(`${API_URL}/im-bestand`);

/**
 * Der aktive Server der Session und die Nachrichten ihrer Kategorien auf
 * ANDEREN Servern (01.10.). Antwort { session_id, server, andere[] }; der
 * aktive Server steht nicht in `andere`.
 */
export const getAndereServer = (sessionId) => api.get(`${API_URL}/andere-server?session_id=${sessionId}`);
